import { useMemo } from 'react';

import { BUDGET_QUIZ_CARD, MINI_QUIZ_CARD } from '../../VendorCardGrid/utils';
import { SearchResultCardView } from '../types/types';
import { useSearchResultsPageContext } from './SearchResultsPageContext';
import { VendorGridCardsContext } from './VendorGridCardsContext';

/**
 * Provides the cards to use in the vendor grid: either vendor cards OR quiz cards
 */
export const VendorGridCardsProvider: React.FC = ({ children }) => {
  const { searchResults, vendorSearch } = useSearchResultsPageContext();

  const vendorOrQuizCardViews = useMemo(() => {
    let cards: SearchResultCardView[] = searchResults.vendors;
    if ((vendorSearch.page || 1) === 1) {
      if (searchResults.shouldInsertBudgetQuiz) {
        cards = [...cards, BUDGET_QUIZ_CARD];
      }
      if (searchResults.shouldInsertMiniQuiz) {
        cards = [...cards, MINI_QUIZ_CARD];
      }
    }
    return cards;
  }, [
    searchResults.vendors,
    searchResults.shouldInsertBudgetQuiz,
    searchResults.shouldInsertMiniQuiz,
    vendorSearch.page,
  ]);

  return (
    <VendorGridCardsContext.Provider
      value={{
        vendorOrQuizCardViews,
      }}
    >
      {children}
    </VendorGridCardsContext.Provider>
  );
};
